import { getSegmentColor } from "./helper";
import type { StrengthConfig } from "./types";

interface StrengthBarProps {
    strengthLevel: number;
    strengthSegments: number;
    password: string;
    strengthConfig: StrengthConfig;
}
const StrengthBar = ({
    strengthLevel,
    strengthSegments,
    password,
    strengthConfig,
}: StrengthBarProps) => (
    <div className='flex h-1 gap-4'>
        {Array.from({ length: strengthSegments }, (_, index) => (
            <div
                key={index}
                className={`grow h-1 rounded-xl ${getSegmentColor(
                    index,
                    strengthLevel,
                    strengthSegments,
                    password,
                    strengthConfig
                )}`}
            />
        ))}
    </div>
);

export default StrengthBar;
